import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SpinnerContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    gap: '12px',
});

const MenuLoadingSpinner = () => {
    return (
        <SpinnerContainer>
            <CircularProgress 
                size={24} 
                thickness={4}
                sx={{ 
                    color: 'rgba(255, 255, 255, 0.7)',
                }} 
            />
            <Typography 
                variant="caption" 
                sx={{ 
                    color: 'rgba(255, 255, 255, 0.6)',
                    fontSize: '12px',
                    textAlign: 'center',
                }}
            >
                Chargement des rapports...
            </Typography>
        </SpinnerContainer>
    );
};

export default MenuLoadingSpinner;
